module.exports = __webpack_public_path__ + "img/STAIKA-logo.c856a8d4.svg";